import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface UpdateSessionParams {
  id: string;
  name?: string;
  startDate?: string;
  endDate?: string;
  isRegistrationFee?: boolean;
  registrationFeeAmount?: number;
  isClassDefault?: boolean;
  isEventDefault?: boolean;
  isArchive?: boolean;
  billingDate?: string;
  registrationFeePerStudent?: Record<number, number>;
  visibleInParentPortal?: boolean;
  chargeLastMonthAtCheckout?: boolean;
  chargeFirstMonthHourlyAtCheckout?: boolean;
  chargeSessionFeesAtEnrollment?: boolean;
}

export const updateSessionByIdAPI = async (params: UpdateSessionParams) => {
  const resp = await baseAPI.patch<unknown>(`/session/${params.id}`, params);
  return resp.data;
};

export const useUpdateSessionByIdMutation = () => {
  return useMutation({
    mutationFn: async (params: UpdateSessionParams) => {
      const response = await updateSessionByIdAPI(params);
      return response;
    },
    onSuccess: (_d) => {
      const keysToInvalidate = [
        [KEYS.SESSIONS],
        [KEYS.STUDIO_DETAILS],
        [KEYS.STUDIO_DETAILS_ALL],
        [KEYS.DASHBOARD_STATUS],
        [KEYS.TOTAL_ACTIVE_CLASSES],
        // All Classes filter dropdown reads sessions from the classes search
        // response, so any session edit (rename, archive, end-date change,
        // visibleInParentPortal flip) needs to invalidate classes too.
        [KEYS.CLASSES],
      ];
      keysToInvalidate.forEach((queryKey) => {
        void queryClient.invalidateQueries({ queryKey });
      });
    },
  });
};
